<div class="modal-header bg-info">
  <h4 class="modal-title pull-left">{{CB.title | localize | async}}</h4>
</div>
<div class="modal-body">
	{{CB.body | localize | async}}
</div>
